module.exports = __webpack_public_path__ + "img/within-company-profile.4f21527.jpg";